(() => {
  'use strict';
  const key = 'sm-saved-pieces-v1';
  const valid = item => item && /^gid:\/\/shopify\/Product\/\d+$/.test(item.productGid) && typeof item.title === 'string' && typeof item.url === 'string' && /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?products\/[a-z0-9-]+(?:\?variant=\d+)?$/.test(item.url);
  const read = () => { try { const items = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(items) ? items.filter(valid).slice(0,100) : []; } catch { return []; } };
  const imageUrl = value => { try { const u = new URL(value, location.origin); return u.protocol === 'https:' && (u.origin === location.origin || u.hostname === 'cdn.shopify.com') ? u.href : ''; } catch { return ''; } };
  const announce = message => document.querySelectorAll('[data-sm-save-status],[data-sm-saved-status]').forEach(e => e.textContent = message);
  const write = items => { try { localStorage.setItem(key, JSON.stringify(items)); } catch { throw new Error('Your browser could not save this piece. Please allow browser storage and try again.'); } refresh(); };
  const updateButtons = () => {
    const saved = read();
    document.querySelectorAll('[data-sm-saved-count]').forEach(e => e.textContent = saved.length ? `(${saved.length})` : '');
    document.querySelectorAll('[data-bb-membership-wishlist]').forEach(b => {
      if (b.dataset.customerAuthenticated === 'true') return;
      const on = saved.some(i => i.productGid === b.dataset.productGid);
      b.setAttribute('aria-pressed', String(on));
      const label = b.querySelector('[data-bb-wishlist-label]');
      if (label) label.textContent = on ? 'SAVED FOR LATER' : 'SAVE FOR LATER';
      const icon = b.querySelector('[aria-hidden="true"]');
      if (icon && icon.tagName.toLowerCase() !== 'svg') icon.textContent = on ? '♥' : '♡';
    });
  };
  function refresh() {
    updateButtons();
    const list = document.querySelector('[data-sm-saved-list]');
    if (!list) return;
    list.replaceChildren();
    const saved = read();
    if (!saved.length) { const p = document.createElement('p'); p.textContent = 'Nothing saved here yet. Tap the heart on a tee or choose Save for later on a product.'; list.append(p); }
    saved.forEach(item => {
      const row = document.createElement('div'); row.className = 'sm-saved-item';
      const img = document.createElement('img'); img.alt = ''; img.loading = 'lazy'; const src = imageUrl(item.image); if (src) img.src = src;
      const a = document.createElement('a'); a.href = item.url; a.textContent = item.title;
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = 'Remove'; remove.setAttribute('aria-label', `Remove ${item.title} from saved pieces`);
      remove.addEventListener('click', () => { const index = [...list.children].indexOf(row); try { write(read().filter(i => i.productGid !== item.productGid)); announce('Piece removed.'); const next = list.children[Math.min(index,list.children.length-1)]?.querySelector('button'); (next || document.querySelector('[data-sm-saved-close]')).focus(); } catch (e) { announce(e.message); } });
      row.append(img,a,remove); list.append(row);
    });
  }
  window.SMSavedPieces = {
    refresh,
    toggle(button) {
      const items = read(); const exists = items.some(i => i.productGid === button.dataset.productGid);
      if (exists) { write(items.filter(i => i.productGid !== button.dataset.productGid)); announce('Removed from saved pieces.'); return false; }
      if (items.length >= 100) throw new Error('Your saved list is full. Remove a piece before saving another.');
      const variant = button.closest('form')?.querySelector('input[name="id"]')?.value;
      const item = {productGid:button.dataset.productGid,title:(button.dataset.productTitle || 'Saved piece').slice(0,200),url:button.dataset.productUrl + (variant && /^\d+$/.test(variant) ? `?variant=${variant}` : ''),image:imageUrl(button.dataset.productImage)};
      if (!valid(item)) throw new Error('This piece could not be saved. Please refresh and try again.');
      write([item,...items]); announce('Saved on this browser. Open Saved pieces to find it again.'); return true;
    }, announce
  };
  let opener;
  document.addEventListener('click', e => {
    const open = e.target.closest('[data-sm-saved-open]'); const close = e.target.closest('[data-sm-saved-close]'); const dialog = document.querySelector('#SMSavedPieces');
    if (open && dialog) { opener = open; refresh(); dialog.showModal(); }
    if (close) dialog?.close();
  });
  const init = () => { refresh(); document.querySelector('#SMSavedPieces')?.addEventListener('close',()=>{if(opener?.isConnected)opener.focus();}); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  window.addEventListener('storage',e=>{if(e.key===key || e.key===null)refresh();});
  document.addEventListener('shopify:section:load',refresh);
})();
